import "../../../styles/input.scss";

import Icon, {iconTypes} from "./Icon.jsx";
import React, {Component} from "react";
import {getPropertyValue, makePropertyValue} from "../util/changeUtils.jsx";

import DropDown from "./DropDown";
import PropTypes from "prop-types";

/**
 * Create a dropdown item
 * @param {object} props
 * @return {node}
 */
function DropdownItem({onClickSelect, index, label, value }) {
    /**
     * Makes the callback
     * @param {object} event
     * @return {undefined}
     */
    function select(event) {
        event.stopPropagation();
        event.preventDefault();

        onClickSelect(index);
    }
    return (
        <div className="dropdown-list-item" onClick={select}>
            <div className={`dropdown-list-item-text noselect ${value?"dropdown-list-item-text-selected":""}`}>{label}</div>
        </div>
    );
}
DropdownItem.propTypes = {
    onClickSelect: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
};

export default class DropDownList extends Component {
    constructor(props){
        super(props);

        this.wrapperRef = React.createRef();
        this.state = {
            lastPickedValue: this.props.placeholder,
        };

        this.toggleList = this.toggleList.bind(this);
        this.onClickSelect = this.onClickSelect.bind(this);
        this.onCloseDropDown = this.onCloseDropDown.bind(this);
    }

    onCloseDropDown(){
        this.props.setDropDown(null);
    }

    toggleList(event) {
        if( event ){
            event.stopPropagation();
            event.preventDefault();
        }

        const {
            options,
        } = this.props;

        const optionsComponent = [];
        // Create selection list
        for(let i=0; i<options.length; i++){
            optionsComponent.push(
                <DropdownItem key={`${i}${options[i].label}`} onClickSelect={this.onClickSelect} index={i} label={options[i].label} value={options[i].value} />
            );
        }

        this.props.setDropDown(
            <DropDown rect={this.wrapperRef.current.getBoundingClientRect()} below={false} isDroppedDown={true} setDropDown={this.props.setDropDown}>
                {optionsComponent}
            </DropDown>
        );
    }

    onClickSelect(index) {
        const {
            options,
            source,
            property,
        } = this.props;
        const value  = options[index].value;
        this.setState({lastPickedValue: value});
        if(getPropertyValue(source, property)!==value){
            this.props.onEdit(makePropertyValue(property, value), source);
        }
        this.onCloseDropDown();
    }

    render() {
        const {
            disabled,
            options,
            source,
            property,
            placeholder,
            selectedIconType,
            strongBorder,
        } = this.props;
        
        // Find the selected option, if available
        let selected = placeholder;
        const currentValue = getPropertyValue(source, property); // || this.state.lastPickedValue;
        // Find the selected option, if available
        for(let i=0; i<options.length; i++){
            if( currentValue===options[i].value ){
                selected = options[i].label;
                break;
            }
        }
       
        //
        return(
            <div className={`dropdown-wrapper ${strongBorder?"strong-border":"normal-border"}`} onClick={disabled?undefined:this.toggleList} style={{opacity:disabled?0.5:1.0}} ref={this.wrapperRef}>
                <div className="dropdown-header" >
                    {selectedIconType!=null ? (
                        <div className="dropdown-selected noselect">
                            {selectedIconType!=null && <div className={selectedIconType}/>}
                            {selected}
                        </div>
                    ) : (
                        <div className="dropdown-selected noselect">{selected}</div>
                    )}
                    <Icon type={iconTypes.down} className="dropdown-icon" style={{zIndex: 0}}/>
                </div>
            </div>
        );
    }
}

DropDownList.propTypes = {
    property: PropTypes.string.isRequired,
    source: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired,  // onEdit(source, change)
    options: PropTypes.array.isRequired,
    setDropDown: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    selectedIconType: PropTypes.string,
    strongBorder: PropTypes.bool,
};

DropDownList.defaultProps = {
    label: null,
    placeholder: "",
    disabled: false,
    strongBorder: false,
};